<template>
  <UContainer
    class="flex flex-col gap-8 py-10 text-sm text-center"
    :class="{ 'text-white': light }"
  >
    <div class="flex flex-col items-center gap-2">
      <AppLogo :light="!light" />
      <p>{{ data.ngo.name }}</p>
      <AppWhoAreWe />
    </div>
    <div class="flex flex-col gap-2">
      <p>{{ data.ngo.address }}</p>
      <p>{{ data.ngo.email }}</p>
      <p>{{ t('comps.footer.org_nr') }} {{ data.ngo.org_number }}</p>
      <p>{{ t('comps.footer.account_nr') }} {{ data.ngo.bank_account }}</p>
      <div class="flex flex-row flex-wrap justify-center gap-2">
        <UButton
          variant="link"
          class="text-inherit"
          :label="t('privacyPolicy.btnLabel')"
          color="inherit"
          @click="showPrivacy"
        /> | <UButton
          variant="link"
          class="text-inherit"
          :label="t('salesTerms.btnLabel')"
          color="inherit"
          @click="showSalesTerms"
        /> | <UButton
          variant="link"
          class="text-inherit"
          :label="t('comps.consent_modal.title')"
          color="inherit"
          @click="consent.show()"
        />
      </div>
    </div>
  </UContainer>
</template>

<script setup lang="ts">
import getData from '#shared/utils/getData'

const { data } = getData()

const showPrivacyModal = useState<boolean>('showPrivacyModal')
const showSalesTermsModal = useState<boolean>('showSalesTermsModal')
const consent = useConsentStore()

function showPrivacy() {
  showPrivacyModal.value = true
}
function showSalesTerms() {
  showSalesTermsModal.value = true
}

defineProps({
  light: {
    type: Boolean,
    required: false,
    default: true,
  },
})
</script>
